import React from "react";
import { useTranslation } from "react-i18next";
import { formatNumber } from "../../utils/functions";

import ErrorIcon from "../../../../static/images/error-icon.svg";

const DrawLine = (props) => {
  var { approvedAmount, totalUsedAmount, currencyCode, holdMount } = props;
  var availableMount = approvedAmount - totalUsedAmount;
  availableMount = Math.round((availableMount + Number.EPSILON) * 100) / 100;
  const { t } = useTranslation();

  const printLine = () => {
    return (
      <div className="credit-line-container d-flex w-100 flex-row justify-content-end">
        {holdMount !== undefined && holdMount !== null && holdMount > 0 && (
          <div className="flex-grow-1 d-flex flex-column justify-content-around">
            <p>{t("dashboard.creditLine.selectedAmount")}</p>
            <h3>{`${formatNumber(holdMount, currencyCode)}`}</h3>
          </div>
        )}

        {availableMount !== undefined &&
          availableMount !== null &&
          availableMount >= 0 && (
            <div className="d-flex flex-column justify-content-around align-items-end px-3 mx-3">
              <p>{t("dashboard.creditLine.available")}</p>
              <h3 className="availableLine">{`${formatNumber(
                availableMount,
                currencyCode
              )}`}</h3>
            </div>
          )}

        {totalUsedAmount !== undefined &&
          totalUsedAmount !== null &&
          totalUsedAmount > 0 && (
            <div className="d-flex flex-column justify-content-around align-items-end px-3">
              <p>{t("dashboard.creditLine.usedAmount")}</p>
              <h3 className="selected-amount">{`${formatNumber(
                totalUsedAmount,
                currencyCode
              )}`}</h3>
            </div>
          )}
      </div>
    );
  };

  return (
    <div className="creditLine">
      {approvedAmount === null ? (
        <div className="error-line">
          <img src={ErrorIcon} alt="Error msj" />
          {t("dashboard.creditLine.notAvailable")}
        </div>
      ) : (
        printLine()
      )}
    </div>
  );
};

export default DrawLine;
